import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=08f0759b&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f0759b"]])

export default __exports__